import React  from 'react';
import Styles from './styles.module.sass';

import { ModalError } from 'components/Error/ErrorModal'
import { useAcountStatus } from 'hooks/useAcountStatus'
import { PaperLess } from 'components/Credito/PaperLess'
import { Error500 } from 'components/Error/Error500'
import SectionLayout from 'newComponents/Layout/SectionLayout';

const SolicitarEstadoCuenta = (props) => {

    const {
        acountStatusData,
        handleSeleccionarOpcion,
        handleSeleccionarFecha,
        handleClose,
        handleConsultar
    } = useAcountStatus(props)



    return (
       props.errorCode >= 500
            ? <Error500 />
            :
                <SectionLayout title="Estado de cuenta" >
                    <div className={Styles?.boxGeneralEstCuentaDesk}>
                        <h2 className={Styles?.subTitle}>Selecciona el periodo que desees consultar:</h2>
                        <div className={Styles?.opcionesRadioDesk}>
                            <ul className={Styles?.ulEstadosD}>
                                <li id="ultimoPd">
                                    <input className={Styles?.radio} onChange={handleSeleccionarOpcion} id="ultimo" type="radio" value={Number(1)} name="discount" checked={Number(acountStatusData?.opcionSeleccionada) === Number(1) ? true : false} />
                                    <label name="ultimo" htmlFor="ultimo" className={Styles?.titleL}>
                                        <span>Último estado de cuenta</span>
                                    </label>
                                </li>

                                <li id="otrosPd">
                                    <input className={Styles?.radio} onChange={handleSeleccionarOpcion} id="otros" type="radio" value={Number(2)} name="discount" checked={Number(acountStatusData?.opcionSeleccionada) === Number(2) ? true : false} />
                                    <label name="otros" htmlFor="otros" className={Styles?.titleL}>
                                    <span>Otros estados de cuenta</span>
                                        <div className={Styles?.boxSelectOpciones}>
                                            <select name="selectDate" onChange={handleSeleccionarFecha} className={Styles?.selectEstados}>
                                                <option selected="selected" disabled>Seleccionar fecha</option>
                                                {acountStatusData?.fechas && acountStatusData?.fechas.map((fe, i) =>
                                                {
                                                    let meses = ['Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
                                                    let dechaDAta = String(fe?.fecha).split('/')
                                                    let fechaFormateada = meses[Number (Number(dechaDAta[0]) - 1)] + " " + dechaDAta[1]
                                                    return <option key={fe?.id} value={fe?.fecha}> {fechaFormateada}</option>
                                                }
                                                )}
                                            </select>

                                        </div>
                                    </label>
                                </li>
                            </ul>
                        </div>

                        <div className={Styles?.btnConsultarDesk} >
                            <button onClick={handleConsultar} disabled={acountStatusData?.buttonActive === 1 ? null : "disabled"}>Consultar</button>
                        </div>
                    </div>
                    
                    {/* <PaperLess /> */}

                    {acountStatusData?.showModal &&
                        <ModalError errorCode={acountStatusData?.errorCode} handleClose={handleClose} />
                    }
                </SectionLayout>
    )
}


export default SolicitarEstadoCuenta